<div class="bl-border-radius--6 bl-padding--24" *ngIf="!showSpinner">
  <header class="bl-text-align--center">
    <div class="bl-row bl-no-gutters bl-justify-content--center bl-padding-bottom--32">
      <svg width="64" height="64" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Verification Shield Icon">
        <path
          d="M42.164 4.01275L24.164 1.01275C24.0553 0.99575 23.9447 0.99575 23.836 1.01275L5.836 4.01275C5.60233 4.0516 5.39004 4.17214 5.23694 4.35289C5.08384 4.53364 4.99987 4.76287 5 4.99975V25.9998C5 32.0578 8.256 37.6118 14.414 42.0598C17.2645 44.1077 20.3839 45.7525 23.684 46.9478C23.889 47.0171 24.111 47.0171 24.316 46.9478C27.6161 45.7525 30.7355 44.1077 33.586 42.0598C39.744 37.6118 43 32.0578 43 25.9998V4.99975C43.0001 4.76287 42.9162 4.53364 42.7631 4.35289C42.61 4.17214 42.3977 4.0516 42.164 4.01275Z"
          fill="#72C472"
        />
        <path
          d="M42.162 4.01277L24.162 1.01277C24.1075 1.00828 24.0526 1.00828 23.998 1.01277V46.9998C24.1058 46.9994 24.2128 46.9819 24.315 46.9478C27.6147 45.7522 30.7337 44.1073 33.584 42.0598C39.742 37.6118 43 32.0578 43 25.9998V4.99977C43.0001 4.7626 42.9159 4.53313 42.7624 4.35234C42.6088 4.17154 42.3961 4.05119 42.162 4.01277Z"
          fill="#4DA34D"
        />
        <path
          d="M36.17 16.5418L22.816 32.1208C22.7264 32.2254 22.6161 32.3103 22.4921 32.3703C22.3681 32.4303 22.2331 32.464 22.0954 32.4694C21.9578 32.4747 21.8205 32.4516 21.6922 32.4014C21.564 32.3512 21.4474 32.2751 21.35 32.1778L13.879 24.7068C13.6915 24.5192 13.5862 24.2649 13.5862 23.9998C13.5862 23.7346 13.6915 23.4803 13.879 23.2928L15.293 21.8788C15.4805 21.6913 15.7348 21.586 16 21.586C16.2651 21.586 16.5194 21.6913 16.707 21.8788L21.887 27.0588L33.132 13.9388C33.3046 13.7375 33.5502 13.613 33.8146 13.5928C34.079 13.5725 34.3407 13.6581 34.542 13.8308L36.061 15.1308C36.1609 15.2162 36.2429 15.3205 36.3025 15.4377C36.362 15.5548 36.3979 15.6826 36.408 15.8137C36.4181 15.9447 36.4023 16.0765 36.3615 16.2014C36.3206 16.3263 36.2555 16.442 36.17 16.5418Z"
          fill="white"
        />
      </svg>
    </div>
    <h2 class="bl-text-style--display-2">
      {{ 'alloyVerify/title' | dictionary }}
    </h2>
    <p class="bl-text-style--default-text-1 bl-padding">
      {{ 'alloyVerify/subtitle' | dictionary }}
    </p>
  </header>

  <hr class="bl-row bl-no-gutters bl-margin-y--32 hr-smoke" />

  <div class="bl-row bl-no-gutters bl-justify-content--center">
    <h4 class="bl-text-style--display-6 bl-flex-direction--row">
      {{ 'alloyVerify/tipsHeader' | dictionary }}
    </h4>
  </div>
  <div class="bl-row bl-no-gutters bl-flex-direction--row bl-width--100">
    <div class="bl-width--50 bl-display--inline-block">
      <div class="bl-display--inline-block bl-flex-direction--column bl-padding-right--16 bl-vertical-align--top">
        <i class="cu-icon cu-id-card icon-size--40"></i>
      </div>
      <div class="bl-display--inline-block bl-text-align--left bl-width--75">
        <h6 class="bl-font-weight--800 bl-font-size--16 bl-margin-bottom--4">{{ 'alloyVerify/tip1Title' | dictionary }}</h6>
        <span class="bl-text-style--secondary-text-1">{{ 'alloyVerify/tip1Text' | dictionary }}</span>
      </div>
    </div>
    <div class="bl-width--50 bl-display--inline-block">
      <div class="bl-display--inline-block bl-flex-direction--column bl-padding-right--16 bl-vertical-align--top">
        <i class="cu-icon cu-sun icon-size--40"></i>
      </div>
      <div class="bl-display--inline-block bl-text-align--left bl-width--75">
        <h6 class="bl-font-weight--800 bl-font-size--16 bl-margin-bottom--4">{{ 'alloyVerify/tip2Title' | dictionary }}</h6>
        <span class="bl-text-style--secondary-text-1">{{ 'alloyVerify/tip2Text' | dictionary }}</span>
      </div>
    </div>
  </div>
  <div class="bl-row bl-no-gutters bl-flex-direction--row bl-width--100 bl-margin-top--16">
    <div class="bl-width--50 bl-display--inline-block">
      <div class="bl-display--inline-block bl-flex-direction--column bl-padding-right--16 bl-vertical-align--top">
        <i class="cu-icon cu-user-circle icon-size--40"></i>
      </div>
      <div class="bl-display--inline-block bl-text-align--left bl-width--75">
        <h6 class="bl-font-weight--800 bl-font-size--16 bl-margin-bottom--4">{{ 'alloyVerify/tip3Title' | dictionary }}</h6>
        <span class="bl-text-style--secondary-text-1">{{ 'alloyVerify/tip3Text' | dictionary }}</span>
      </div>
    </div>
    <div class="bl-width--50 bl-display--inline-block">
      <div class="bl-display--inline-block bl-flex-direction--column bl-padding-right--16 bl-vertical-align--top">
        <i class="cu-icon cu-mobile-photo icon-size--40"></i>
      </div>
      <div class="bl-display--inline-block bl-text-align--left bl-width--75">
        <h6 class="bl-font-weight--800 bl-font-size--16 bl-margin-bottom--4">{{ 'alloyVerify/tip4Title' | dictionary }}</h6>
        <span class="bl-text-style--secondary-text-1">{{ 'alloyVerify/tip4Text' | dictionary }}</span>
      </div>
    </div>
  </div>

  <div class="bl-row bl-no-gutters bl-justify-content--center bl-padding-top--32 bl-flex-direction--row">
    <button class="bl-button bl-width--100 bl-bg-color-primary" id="btn-alloy-verify" (click)="verifyIdentity()">
      <span class="bl-font-size--14 bl-font-weight--700">
        {{ 'alloyVerify/ctaText' | dictionary }}
      </span>
    </button>
  </div>
</div>
<ng-container *ngIf="showSpinner">
  <!-- <p class="bl-margin-y--24 bl-font-color--steel" [innerHTML]="'alloyVerify/loadingText' | dictionary"></p> -->
  <ecp-content-spinner></ecp-content-spinner>
</ng-container>
